import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const fieldFn = /* @__PURE__ */ createRecipe('field', {
  "fullWidth": false
}, [])

const fieldVariantMap = {
  "fullWidth": [
    "true"
  ]
}

const fieldVariantKeys = Object.keys(fieldVariantMap)

export const field = /* @__PURE__ */ Object.assign(memo(fieldFn.recipeFn), {
  __recipe__: true,
  __name__: 'field',
  __getCompoundVariantCss__: fieldFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: fieldVariantKeys,
  variantMap: fieldVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, fieldVariantKeys)
  },
  getVariantProps: fieldFn.getVariantProps,
})